import { render } from "./CTA.vue?vue&type=template&id=06fa325a&scoped=true"
import script from "./CTA.vue?vue&type=script&lang=js"
export * from "./CTA.vue?vue&type=script&lang=js"

import "./CTA.vue?vue&type=style&index=0&id=06fa325a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06fa325a"]])

export default __exports__